module.exports = __webpack_public_path__ + "static/media/table-icon.54daf0c3.svg";